export const DATA_USER = "/capture/user";
